export default function(handler, period = 500, options = {}) {
    let trailing = true;
    if (options.trailing === false) {
        trailing = false
    }

    return function() {
        if(!handler.isInactive) {
            handler.isInactive = true;
            handler(...arguments);
            setTimeout(() => {
                handler.isInactive = false;

                if (trailing) {
                    handler(...arguments);
                }
            }, period);
        }
    };
}
